<template>
  <v-card-row actions>
    <v-btn icon v-clipboard:copy="url" v-clipboard:success="() => snackbar = true"><v-icon>link</v-icon></v-btn>
    <div class="caption"><a :href="url" target="_blank">{{ url }}</a></div>
    <v-spacer />
    <v-btn
      v-if="$can('update', 'services')"
      router
      :href="{ name: 'Service', params: { id: service.id } }"
      primary light
      class="ml-2">
      {{ $t('service.actions.edit') }}
    </v-btn>
    <v-snackbar v-model="snackbar">
      {{ $t('service.actions.copy') }}
      <v-btn icon light flat @click.native="snackbar = false"><v-icon>close</v-icon></v-btn>
    </v-snackbar>
  </v-card-row>
</template>

<script>
  import Service from '@/api/service'
  export default {
    props: {
      service: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        snackbar: false
      }
    },
    computed: {
      url () {
        return Service.isOfferType(this.service.service_type)
          ? this.service.url
          : this.service.url.replace('/o/', '/p/')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/service/Actions.vue